import { AUTH_RESET, AUTH_SET_TOKEN, AuthAction } from 'actions/auth/AuthActionsTypes';

export const setAuthToken = (token: string): AuthAction => {
    return {
        type: AUTH_SET_TOKEN,
        payload: {
            token
        }
    };
};

export const clearAuthToken = (): AuthAction => ({
    type: AUTH_RESET
});
